import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectResultPuids } from '../../../../../shared/selectors/results/selectResultPuids';
import { addAdFoxBanner } from '../../../../../shared/serp/components/adfox';
import { FOfferType } from '../../../../JsonQuery';
import { BannerInFilter } from '../../components/advancedFilters/common/BannerInFilter';
import { selectIsUserAgent } from '../../selectors';
import { useContext } from '../../utils/useContext';
import { useOfferType } from '../../utils/useOfferType';

export function PikBannerInFiltersContainer() {
  const {
    appContext: { makeRequest },
    currentLocation,
  } = useContext();

  const puids = useSelector(selectResultPuids);
  const offerType = useOfferType();
  const isAgent = useSelector(selectIsUserAgent);

  const locationId = useMemo(() => {
    if (currentLocation === 'moscow_mo') {
      return 1;
    }
    if (currentLocation === 'spb_lo') {
      return 2;
    }

    return currentLocation.parentId || currentLocation.id;
  }, [currentLocation]);

  const banner = useMemo(() => {
    return addAdFoxBanner({
      type: 'picture_banner',
      key: 'picture_banner',
      makeRequest,
      locationId,
      isAgent,
      puids,
      isNew: true,
      width: '100%',
      minHeight: '100px',
      postViewAnalyticsData: {
        banner: {
          place: 'offersSerp',
          name: 'Listing_filter_more',
        },
      },
    });
  }, []);

  if (offerType !== FOfferType.FlatNew) {
    return null;
  }

  return <BannerInFilter>{banner}</BannerInFilter>;
}
